import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import { transformEnterprise } from './enterprises.transformers';
import type { EnterprisesCollection } from './enterprises.types';

export function enterprisesReducer(
  state: CollectionStateSlice<EnterprisesCollection> = {},
  action: CollectionActions<EnterprisesCollection>,
): CollectionStateSlice<EnterprisesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'enterprises') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<EnterprisesCollection>(
          state,
          transformIntoDocuments(result.enterprises, transformEnterprise),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'enterprises') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<EnterprisesCollection>(
          state,
          transformIntoDocuments([result.enterprise], transformEnterprise),
          ref,
        );
      }
      return state;
    }
    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'enterprises') {
        const { delta, originalDocument, ref } = action.payload;
        return updateWebsocketDocuments<EnterprisesCollection>(
          state,
          [originalDocument.id],
          enterprise => ({
            ...enterprise,
            ...delta,
            logoFileId: delta.logoFileId ?? originalDocument.logoFileId,
            avatarFileId: delta.avatarFileId ?? originalDocument.avatarFileId,
          }),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
